import { MoneyApi } from "go-core/api/types";
import { CustomerApi, PriceConfiguratorContentApi } from "../types";

export interface UpdateSubscriptionsApi {
	subscriptions: UpdateSubscriptionApi[];
	license_levels: any[];
	coupon_code?: string;
}

export interface UpdateBaseSubscriptionApi {
	edit_mode: string;
	family_id: string;
	external_id: string;
	billing_period: string;
	plan_id: string;
	addons: UpdateAddonApi[];
	status: string;
	cancellation_reason?: string;
	reason_details?: string;
	scheduled_cancellation_at?: string;
}

export interface UpdateSubscriptionApi extends UpdateBaseSubscriptionApi {
	monthly_sub_item?: UpdateBaseSubscriptionApi;
}

export interface UpdateAddonApi {
	addon_id: string;
	quantity: number | null;
	terms?: {
		name: string;
		accepted: boolean;
	};
}

export enum SubscriptionVisibility {
	VISIBLE = "VISIBLE",
	READ_ONLY = "READ_ONLY",
	HIDDEN = "HIDDEN",
}

export interface SubscriptionVisibilityApi {
	visibility: SubscriptionVisibility;
}

export enum SubscriptionLicenseType {
	TRIAL = "TRIAL",
	STANDARD = "STANDARD",
	CANCELLED = "CANCELLED",
	NONE = "NONE",
	FUTURE = "FUTURE",
	MANUAL = "MANUAL",
	PAUSED = "PAUSED",
}

export interface SubscriptionsApi {
	total_price: MoneyApi;
	total_money: MoneyApi;
	totals: SubscriptionTotalApi[];
	customer: CustomerApi;
	subscriptions: SubscriptionApi[];
	license_levels: any[];
	warnings?: SubscriptionWarningApi;
}

export interface SubscriptionTotalApi {
	billing_period: string;
	total_price: MoneyApi;
	sub_total_price: MoneyApi;
	discount_price: MoneyApi;
}

export interface BaseSubscriptionApi {
	family_id: string;
	family_name: string;
	billing_period: string;
	plan_id: string;
	status: string;
	subscription_money: MoneyApi;
	total_money: MoneyApi;
	addons: AddonApi[];
	send?: boolean;
	current_term_end?: string;
	current_term_start?: string;
	next_billing_at?: string;
	cancelled_at?: string;
	pause_date?: string;
	resume_date?: string;
	trial_start?: string;
	trial_end?: string;
	priority: number;
	cancellation_reason?: string;
	reason_details?: string;
	cancel_date?: string;
	name: string;
	description: string;
	edit_mode: string;
	external_id: string;
	cancelled_editable?: boolean;
	expires_at?: string;
	actual_subscription_exist: boolean;
	warning?: SubscriptionWarningApi;
}

export interface SubscriptionApi extends BaseSubscriptionApi {
	monthly_sub_item?: BaseSubscriptionApi;
}

export interface AddonApi {
	addon_id: string;
	quantity: number | null;
	unit_price: MoneyApi;
	total_price: MoneyApi;
	name: string;
	warning?: SubscriptionWarningApi;
}

export interface SubscriptionWarningApi {
	code: string;
	usage_value: number;
	feature: string;
	max_value?: number;
}

export interface AddonValidationApi {
	data_type: string;
	default_value: string;
	min_value: number;
	max_value: number;
	required: boolean;
}

export interface AvailableSubscriptionContentsApi {
	currency: string;
	contents: PriceConfiguratorContentApi[];
}

export interface SubscriptionInvoiceApi {
	proforma_id: string;
	proforma_number: string;
	invoice_id: string;
	invoice_number: string;
	paid_money: MoneyApi;
	due_money: MoneyApi;
	payment_error?: string;
	last_paid_at: string;
	status: string;
	paid_at: string;
	due_date: string;
	proforma_created_at: string;
	total_money: MoneyApi;
	total_without_credits_and_adjustments_money: MoneyApi;
	payment_status: string;
	expiry_date: string;
	blocked: boolean;
}

export interface PauseSubscriptionApi {
	family_id: string;
	resume_date: string;
	pause_date: string;
}

export interface ResumeSubscriptionApi {
	family_id: string;
	resume_date: string;
}

export interface CancelSubscriptionApi {
	reason: string;
	reason_details: string;
	cancel_date: string;
}
